const toHtmlColor = (color: number | string): string => {
  return `#${(Number(color) + Math.pow(16, 6)).toString(16).slice(-6).toUpperCase()}`;
};

export default toHtmlColor;
